import * as yup from 'yup';

import {
  ChangeEmployerBillingFormFields,
  ChangeVerifierBillingFormFields,
} from 'src/types/billing';

import { dollarValueValidationSchema } from './money';
import { percentsValidationSchema } from './percents';

export const percentsInputValidationSchema = yup.object({
  [ChangeEmployerBillingFormFields.revenueShareValue]: percentsValidationSchema,
});
export const flatInputValidationSchema = yup.object({
  [ChangeEmployerBillingFormFields.revenueShareValue]: dollarValueValidationSchema,
});
export const verifierBillingValidationSchema = yup.object({
  [ChangeVerifierBillingFormFields.voi]: dollarValueValidationSchema,
  [ChangeVerifierBillingFormFields.voe]: dollarValueValidationSchema,
  [ChangeVerifierBillingFormFields.reverification]: dollarValueValidationSchema,
});
